//===============================================================================================================
// SCA Extension: ItemsSearcher.Collection.Extension
//===============================================================================================================
define('ItemsSearcher.Collection.Extension',
    [
        'ItemsSearcher.Collection',
        'SC.Configuration',
        'underscore'
    ],
    function (
        ItemsSearcherCollection,
        Configuration,
        _
    )
    {
        'use strict';

        _.extend(ItemsSearcherCollection.prototype, {
            initialize: _.wrap(ItemsSearcherCollection.prototype.initialize, function(fn) {
                fn.apply(this, _.toArray(arguments).slice(1));

                // need to pull this outside in order to use custom string in the configuration as the field ID
                var filterObj = {};

                if(Configuration.get('scaWebsiteItemDisplay')){
                    filterObj[Configuration.get('scaWebsiteItemDisplayFieldId')] = Configuration.get('scaWebsiteItemDisplay').join();
                }
                // add custom parameter. We want to ensure to only display items on the website that have these facets set.
                this.searchApiMasterOptions = _.extend( filterObj,  Configuration.get(this.options.searcherAPIConfiguration));
            })
        });
    }
);
